<template>
  <section class="section">
    <div class="container">
      <div class="columns">
        <div class="column is-10">
          <h1 class="title">{{ $translate(title) | capitalize }}</h1>
        </div>
        <div class="column has-text-right">
          <button slot="trigger" type="button" class="button is-primary" :disabled="permissionDenied" @click="send">
            <b-icon icon="content-save-outline"></b-icon>
          </button>
        </div>
      </div>
      <b-field
        horizontal
        :label="$translate('name') | capitalize"
        :type="{ 'is-danger': errors.has('name') }"
        :message="errors.first('name')"
      >
        <b-input v-model="catalog.name" v-validate="'required|unique'" :disabled="permissionDenied" name="name">
        </b-input>
      </b-field>
      <div class="field is-horizontal">
        <div class="field-label is-normal type-label">
          <p class="label">{{ $translate('catalog_type') }}</p>
        </div>
        <div class="field-body">
          <b-tag class="module-tag" :type="config.tagColor ? config.tagColor : ''">{{
            $translate(catalog.type)
          }}</b-tag>
        </div>
      </div>

      <b-tabs>
        <b-tab-item :label="$translate('customers') | capitalize">
          <h1 class="title">
            {{ $translate('customers') | capitalize }}
          </h1>
          <div class="columns">
            <div class="column is-6 companycontainer">
              <template v-for="(company, index) in companies">
                <b-field
                  v-if="index <= companies.length / 2 && checkCompanyModule(company)"
                  :key="company.id"
                  horizontal
                  :label="company.name"
                >
                  <b-switch
                    v-model="company.catalogbool"
                    :disabled="permissionDenied"
                    @input="checkCompanyCatalog(company)"
                  ></b-switch>
                </b-field>
              </template>
            </div>
            <div class="column is-6 companycontainer">
              <template v-for="(company, index) in companies">
                <b-field
                  v-if="index > companies.length / 2 && checkCompanyModule(company)"
                  :key="company.id"
                  horizontal
                  :label="company.name"
                >
                  <b-switch
                    v-model="company.catalogbool"
                    :disabled="permissionDenied"
                    @input="checkCompanyCatalog(company)"
                  ></b-switch>
                </b-field>
              </template>
            </div>
          </div>
        </b-tab-item>
        <b-tab-item :label="$translate('materials') | capitalize">
          <h1 class="title">
            {{ $translate('materials') | capitalize }}
          </h1>
          <b-tabs vertical>
            <b-tab-item
              v-for="material in moduleMaterials"
              :key="material"
              :label="$translate(material) | capitalize"
              :materialtext="material"
            >
              <GeneralTableMaterial
                ref="MaterialTable"
                :module="module"
                :materialtext="material"
                :catalog.sync="catalog.material[material]"
                :catalogmodels.sync="catalog.model"
                :realmodelcatalog.sync="realmodelcatalog"
                :permission-denied.sync="permissionDenied"
                @updateModelCatalog="$refs.ModelCataolog.updateAfterload()"
              />
            </b-tab-item>
          </b-tabs>
        </b-tab-item>
        <b-tab-item :label="$translate('models') | capitalize">
          <h1 class="title">
            {{ $translate('models') | capitalize }}
          </h1>
          <ModelsCatalog
            ref="ModelCataolog"
            :module="module"
            :catalog.sync="catalog.model"
            :catalogmat.sync="catalog.material"
            :permission-denied.sync="permissionDenied"
            :realmodelcatalog.sync="realmodelcatalog"
            :availablepell="availablepell"
            :availablerip="availablerip"
            @updateMaterials="
              $refs.MaterialTable.forEach(temp => {
                temp.updateAfterload()
              })
            "
          />
        </b-tab-item>
      </b-tabs>
    </div>
  </section>
</template>

<script>
import GeneralTableMaterial from './components/GeneralTableMaterial'
import ModelsCatalog from './components/ModelsCatalog'
import permissionMixin from '@/helpers/mixins/permissionMixin'
import materialTools from '@/helpers/mixins/materialTools'

export default {
  $_veeValidate: {
    validator: 'new',
  },

  name: 'CatalogForm',
  components: {
    GeneralTableMaterial,
    ModelsCatalog,
  },
  mixins: [permissionMixin, materialTools],
  props: ['module'],
  data() {
    return {
      id: null,
      title: null,
      permissionDenied: false,
      companies: [],
      realmodelcatalog: [],
      availablepell: [],
      availablerip: [],
      catalog: {
        material: {},
        model: {},
        type: '',
      },
    }
  },
  computed: {
    moduleMaterials() {
      return this.$availableMaterials[this.module]
    },
    config() {
      return this.$moduleConfiguration[this.module]
    },
  },
  created() {
    this.id = this.$route.params.id
    this.title = this.id !== undefined ? this.$translate('modify_catalog') : this.$translate('new_catalog')
  },
  async mounted() {
    let isAllowed = false
    switch (this.userInfo.type) {
      case 'A':
        isAllowed = true
        this.permissionDenied = false
        break
      case 'I':
        isAllowed = true
        this.permissionDenied = this.userInfo.level !== 'S'
        break
    }
    if (!isAllowed) this.$router.push('/forbidden')

    this.$validator.extend('unique', async value => {
      let counter = 0
      await this.$db
        .collection('catalogs')
        .where('name', '==', value)
        .get()
        .then(snapshot => {
          snapshot.forEach(doc => {
            if (doc.id !== this.id) {
              counter++
            }
          })
        })

      return counter <= 0
    })

    if (this.module === 'modular') {
      this.availablepell = await this.getMaterialArray(this.config.materials.Pel)
      this.availablerip = await this.getMaterialArray(this.config.materials.Rip)
    }

    if (this.id) {
      this.loadDatatoEdit()
    } else {
      if (this.$route.params.idtocopy) {
        this.loadDatatoCopy()
      } else {
        for (let material in this.moduleMaterials) {
          this.catalog.material[this.moduleMaterials[material]] = {}
        }
      }
      this.catalog.type = this.module
    }
    await this.$db
      .collection('companies')
      .get()
      .then(async snapshot => {
        snapshot.forEach(doc => {
          let newcomp = doc.data()
          newcomp.id = doc.id
          if (!newcomp.moduleTailored && !newcomp.moduleFits && !newcomp.moduleModular) {
            newcomp.moduleTailored = true
            newcomp.moduleFits = false
            newcomp.moduleModular = false
          }
          if (this.id) {
            newcomp.catalogbool = newcomp[this.config.catalogType] === this.id
          } else {
            newcomp.catalogbool = newcomp.id === this.$route.params.companyId
          }
          this.companies.push(newcomp)
        })
        let names = []
        let tempdictionary = []
        this.companies.forEach(comp => {
          names.push(comp.name)
        })
        //console.log(names);
        names = names.sort()
        //console.log(names);

        for (let x = 0; x < names.length; x++) {
          tempdictionary.push(this.companies.find(el => el.name === names[x]))
        }
        // console.log(tempdictionary);
        this.companies = tempdictionary
      })
  },
  methods: {
    checkCompanyModule(tempcompany) {
      if (this.catalog.type === 'tailored') {
        return tempcompany.moduleTailored
      }
      if (this.catalog.type === 'fits') {
        return tempcompany.moduleFits
      }
      if (this.catalog.type === 'modular') {
        return tempcompany.moduleModular
      }
      if (this.catalog.type === 'insole') {
        return tempcompany.moduleInsole
      }
    },

    checkCompanyCatalog(tempcompany) {
      const catalogKey = this.$moduleConfiguration[this.catalog.type].catalogType
      const catalogToCheck = tempcompany[catalogKey]

      if (catalogToCheck && catalogToCheck !== this.id && tempcompany.catalogbool) {
        this.$buefy.dialog.confirm({
          title: this.$translate('attention'),
          message: this.$translate('catalog_message_present'),
          cancelText: this.$translate('undo'),
          confirmText: this.$translate('catalog_confirm'),
          type: 'is-danger',
          hasIcon: true,
          onCancel: () => (tempcompany.catalogbool = false),
        })
      }
    },
    loadDatatoCopy() {
      this.$db
        .collection('catalogs')
        .doc(this.$route.params.idtocopy)
        .get()
        .then(doc => {
          this.catalog = doc.data()
          if (!this.catalog.type) {
            this.catalog.type = 'tailored'
          }
          this.catalog.name = this.catalog.name + '(copy)'
        })
    },
    loadDatatoEdit() {
      this.$db
        .collection('catalogs')
        .doc(this.id)
        .get()
        .then(doc => {
          this.catalog = doc.data()
          if (!this.catalog.type) {
            this.catalog.type = 'tailored'
          }
        })
    },
    send() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$buefy.notification.open({
            duration: 3000,
            message: this.$translate('success_form'),
            type: 'is-success',
          })
          if (this.id) {
            this.$db
              .collection('catalogs')
              .doc(this.id)
              .update(this.catalog)
              .then(() => {
                for (let company in this.companies) {
                  if (this.companies[company].catalogbool) {
                    this.$db
                      .collection('companies')
                      .doc(this.companies[company].id)
                      .update({ [this.$moduleConfiguration[this.catalog.type].catalogType]: this.id })
                  } else {
                    if (
                      this.companies[company].catalog === this.id ||
                      this.companies[company].catalog_fits === this.id ||
                      this.companies[company].catalog_modular === this.id ||
                      this.companies[company].catalog_insole === this.id
                    ) {
                      this.$db
                        .collection('companies')
                        .doc(this.companies[company].id)
                        .update({ [this.$moduleConfiguration[this.catalog.type].catalogType]: null })
                    }
                  }
                }
                this.$router.push({ name: 'catalogs' })
              })
          } else {
            this.$db
              .collection('catalogs')
              .add(this.catalog)
              .then(doc => {
                this.id = doc.id
                for (let company in this.companies) {
                  if (this.companies[company].catalogbool) {
                    this.$db
                      .collection('companies')
                      .doc(this.companies[company].id)
                      .update({ [this.$moduleConfiguration[this.catalog.type].catalogType]: this.id })
                  }
                }
              })
            this.$router.push({ name: 'catalogs' })
          }

          return
        }
        this.$forceUpdate()
        this.$buefy.notification.open({
          duration: 3000,
          message: this.$translate('failed_form'),
          type: 'is-danger',
        })
      })
    },
  },
}
</script>
<style scoped>
.container >>> .companycontainer .field-label {
  -ms-flex-preferred-size: 0;
  flex-basis: 0;
  -webkit-box-flex: 4;
  -ms-flex-positive: 1;
  flex-grow: 4;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  margin-right: 1.5rem;
  text-align: left;
}

.field-label.type-label {
  padding-top: 0;
  text-transform: capitalize;
}
</style>
